import React, { useState, useRef, useEffect } from 'react';
import s from './About.module.scss';
import clsx from 'clsx';
import { ReactComponent as DropDown } from 'images/new-icons/arrow-down-icon.svg';
import { ReactComponent as RiyalIcon } from 'images/new-icons/riyal.svg';
import { useTranslation } from 'react-i18next';

const About = ({ description, product, name }) => {

  const {t} = useTranslation() as any;
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTextOverflowing, setIsTextOverflowing] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  const toggleExpand = () => {
    setIsExpanded(prev => !prev);
  };

  useEffect(() => {
    const textElement = textRef.current;
    if (textElement) {
      setIsTextOverflowing(textElement.scrollHeight > textElement.clientHeight);
    }
  }, [description]);

  const hasDescription = typeof description === 'string' && description.trim().length > 0 && description !== '{}';

  return (
    <div className={clsx(s.about, !hasDescription && s.about_no_description)}>
      <div className={s.about_info}>
        <div className={`${s.about_info_text} ${isExpanded ? s.expanded : s.collapsed}`}>
          {name || ''}
        </div>

        {hasDescription && (
          <>
            <div
              ref={textRef}
              className={`${s.about_info_text_secondary} ${isExpanded ? s.expanded : s.collapsed}`}
            >
              {description}
            </div>
            {isTextOverflowing && (
              <div className={clsx(s.about_info_view_more, s.head_text)} onClick={toggleExpand}>
                {isExpanded ? t('View Less') : t('View More')}
              </div>
            )}
          </>
        )}
      </div>
      <div className={s.bottom}>
        <div className={s.bottom_inner}>
          <div className={s.bottom_inner_price}>{t('Price')}</div>
          <div className={s.bottom_inner_curr}>
            <RiyalIcon />
            {product?.price}
          </div>
        </div>
        <div className={s.bottom_inner}>
          <div className={s.bottom_inner_price}>{t("Duration")}</div>
          <div className={s.bottom_inner_curr}>{product?.duration}</div>
        </div>
      </div>
    </div>
  );
};

export default About;
